var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:["opc-succezz__subtitle__desc", _vm.greyBackground ? "opc-succezz__subtitle__grey" : ""],domProps:{"innerHTML":_vm._s(_vm.subTitle)}})}
var staticRenderFns = []

export { render, staticRenderFns }